export enum UserType {
  Admin = 'Admin',
  Collaborator = 'collaborator',
  Manager = 'manager'
}
